import { writable } from "svelte/store";

export const alertState = writable({ message: "", resolve: null });

export function showAlert(msg) {
    return new Promise((resolve) => {
        alertState.update((state) => {
            if (state.resolve) state.resolve();
            return { message: String(msg ?? ""), resolve };
        });
    });
}

export function closeAlert() {
    alertState.update((state) => {
        if (state.resolve) state.resolve();
        return { message: "", resolve: null };
    });
}

window.alert = showAlert;
